<template>
  <div v-loading.fullscreen.lock="loading">
    <!-- 售中问题提出 -->
    <el-dialog :title="$t('message.issueSubmissionDuringSale')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1820px" :before-close="handleClose">

      <div class="table">
        <ol>
          <!-- 选择 -->
          <li class="flex05">{{ $t('message.choose') }} </li>
          <!-- 二维码上传 -->
          <li>{{ $t("message.qrCodeUpload") }}</li>
          <!--  订单号-->
          <li class="flex15">
            {{ $t("message.orderNumber") }}
          </li>
          <li class="flex05">NO</li>
          <!--店铺信息-->
          <li>{{ $t("message.storeInformation") }}</li>
          <!--照片-->
          <li>{{ $t("message.pic") }}</li>
          <!-- 商品属性 -->
          <li class="flex15">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
          <!--附加服务  -->
          <li class="flex15">{{ $t("message.additionalServices") }}</li>
          <!--实时数量  -->
          <li>{{ $t("message.realTimeQuantity") }}</li>
          <!--商品状态  -->
          <li>{{ $t("message.itemStatus") }}</li>
          <!-- 问题类别 -->
          <li class="flex15">{{ $t("message.typeOfProblem") }}</li>
          <!-- 问题图片 -->
          <li class="flex2">{{ $t("message.problemPic") }}</li>
          <!-- 问题产品数 -->
          <li>{{ $t("message.problemNunber") }}</li>
          <!-- 问题描述  -->
          <li class="flex2">
            {{ $t("message.problemDescription") }}
          </li>
        </ol>
        <!-- 订单详情 -->
        <div class="inSaleDetail">
          <ul v-for="(items, indexs) in problemList" :key="indexs">
            <!-- 选择 -->
            <li class="flex05">
              <label class="label">
                <el-checkbox v-model="items.checked" @change="changeItem"></el-checkbox>
              </label>
            </li>
            <!-- 二维码上传 -->
            <li>
              <el-button @click="handlePictureCardPreview(items.qrcode_path, indexs, items.code)" type="primary"
                size="mini" class="qrCodeUpload">
                {{ $t("message.qrCodeUpload") }}
              </el-button>
            </li>
            <!--  订单号-->
            <li class="flex15">
              <div>
                <p>
                  <router-link :to="'/orderPaymentDetail?order_sn=' + items.order_sn" class="a-link" target="_blank">
                    {{ items.order_sn }}</router-link>
                </p>
              </div>
            </li>
            <li class="flex05">{{ items.sorting }}</li>
            <!--店铺信息-->
            <li>{{ items.shop_name }}</li>
            <!--照片-->
            <li>
              <div class="img">
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                    <img :src="items.pic" alt="" />
                  </a>
                </el-popover>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                  <span>{{ skuItem.key }}:</span>
                  <span>{{ skuItem.value }}</span>
                </p>
              </div>
            </li>
            <!--附加服务  -->
            <li class="flex15">
              <div class="scope" v-if="items.option != null">
                <el-popover placement="bottom-start" width="500" trigger="click">
                  <el-table :data="items.option" border size="mini" show-summary max-height="600px">
                    <el-table-column property="name" label="附加服务(中文)" align="center"></el-table-column>
                    <el-table-column property="name_translate" label="附加服务（日文）" align="center"></el-table-column>
                    <el-table-column property="num" label="数量" align="center"></el-table-column>
                    <el-table-column label="单价.元" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.price }}
                      </template>
                    </el-table-column>
                    <el-table-column label="单位" align="center" property="unit">
                    </el-table-column>
                    <el-table-column label="小计.元" align="center" property="total">
                    </el-table-column>
                  </el-table>
                  <div class="template" slot="reference">
                    <div style="height: 100px">
                      <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </div>
              <!-- <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div style="height: 100px">
                    <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip> -->
            </li>
            <!-- 实时数据 -->
            <li>
              <div class="template">
                <!-- 可入库 -->
                <p>
                  {{ $t("message.canBePutIntoStorage") }}:{{ items.possible_num ? items.possible_num : "——" }}
                </p>
                <!-- 已到货 -->
                <p>
                  {{ $t("message.itHasArrived") }}:{{ items.storage_num ? items.storage_num : "——" }}
                </p>
                <!-- 已出货 -->
                <p>
                  {{ $t("message.hasBeenShipped") }}:{{ items.p_num ? items.p_num : "——" }}
                </p>
              </div>
            </li>
            <!--商品状态  -->
            <li>{{ items.status_name }}</li>
            <!-- 问题类别 -->
            <li class="flex15">
              <el-select v-model="items.type" placeholder="空白" size="small" filterable @change="allType($event, items)">
                <el-option v-for="(item, index) in problemTypes" :key="index" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </li>
            <!-- 问题图片 -->
            <li class="flex2">
              <div class="images">
                <div class="imgList">
                  <div class="imgs" v-for="(imgs, imgIndex) in items.image" :key="imgIndex"
                    @click="getIndex(indexs, imgIndex)">
                    <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                      :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                      <img v-if="imgs.image" :src="imgs.image" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <!-- <el-checkbox v-model="imgs.checked"></el-checkbox> -->
                  </div>
                </div>
              </div>
            </li>
            <!-- 问题产品数 -->
            <li>
              <el-input v-model="items.num" :placeholder="$t('message.problemNunber')" size="small"
                @input="changeAccount(indexs, items, 'num', items.num)" type="number"
                onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" onfocus="this.select()"></el-input>
            </li>
            <!-- 具体问题描述 -->
            <li class="flex2">
              <el-input v-model="items.description" type="textarea" :placeholder="$t('message.problemDescription')"
                onfocus="this.select()"
                @input="changeAccount(indexs, items, 'description', items.description)"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-checkbox v-model="checked" @change="allChecked" style="margin-left: 15px;">全选</el-checkbox>
        <!--提出问题产品  -->
        <el-button type="primary" @click="problemStore" style="margin-left: 50px">
          {{ $t("message.problemProductProposal") }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="imgDialogVisible" width="500px" :close-on-click-modal="false"
      @close="getMobileUploadImage">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import NP from 'number-precision' //NP.strip 处理浮点数
export default {
  props: ['porder_sn'],
  data() {
    return {
      dialogVisible: false,
      imgDialogVisible: false,
      checked: false,
      dialogImageUrl: '',
      indexs: {},
      checkedList: [],
      loading: false,
      isShow: localStorage.getItem('japanUserRoleStatus') != 5 ? true : false,
      problemTypes: [{ name: 'option变更', value: 1 }, { name: '商品少货', value: 2 }, { name: '不良', value: 3 },],
      problemList: []
    };
  },
  computed: {
  },
  methods: {
    storePreview(order_detail_id,) {
      this.$api.inSaleApi.storePreview({ order_detail_id, porder_sn: this.porder_sn }).then(res => {
        res.data.forEach(item => {
          item.type = ''
          item.image = [{ image: '' }, { image: '' }, { image: '' }, { image: '' },]
          if (item.option != null) {
            item.option.forEach((opti) => {
              opti.total = 0
              // 按照% 收手续费
              if (opti.price_type == 1) {
                opti.total =
                  NP.strip(item.confirm_price * opti.num * (opti.price / 100));
              } else {
                opti.total = opti.num * opti.price;
              }
              opti.total = NP.strip(opti.total)
            });
          }
        })


        this.problemList = res.data
        this.dialogVisible = true
        console.log(res);

      })
    },
    handleClose() {
      this.$confirm(this.$t("message.confirmTheShutDown"))
        .then((_) => {
          this.dialogVisible = false
        })
        .catch((_) => { });
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      let list = []
      this.problemList.forEach((item) => {
        if (item.checked) {
          this.checkedList.push(item);
        }
        list.push(item)
      });
      this.checked = this.checkedList.length == list.length
      this.$forceUpdate();
    },
    // 全选
    allChecked() {
      this.checkedList = [];
      this.problemList.forEach((item) => {
        item.checked = this.checked
        this.checkedList.push(item);
      });
      this.$forceUpdate();
    },
    // 获取图片索引
    getIndex(indexs, imgIndex) {
      this.indexs = {
        items_i: indexs,
        imgs_i: imgIndex,
      };
    },
    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      // this.loading = true;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        // this.loading = false;
      }
      return isJPG || isPNG;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      // this.loading = false;
      if (file.code != 0) return this.$message.error(file.msg);
      this.$message.success(file.msg);
      let image = this.problemList[this.indexs.items_i].image[
        this.indexs.imgs_i
      ]
      image.image = file.data;
      image.checked = true
      console.log(image);
      this.$forceUpdate();
    },
    //最大数量
    changeAccount(indexs, data, type, val) {
      if (data.num > data.confirm_num) {
        this.problemList[indexs].num = data.confirm_num;
      }
      if (data.checked) {
        this.problemList.forEach((item) => {
          if (item.checked) {
            item[type] = val
          }
        });
      }
      this.$forceUpdate()
    },
    // 提出订单
    problemStore() {
      let datas = {
        list: [],

      };
      this.problemList.forEach((item) => {
        item.image.forEach(images => {
          images.client_show = images.checked ? 1 : 0
        })
        datas.list.push({
          order_detail_id: item.order_detail_id,
          description: item.description,
          num: item.num,
          image: item.image,
          type: item.type,
          porder_sn: item.porder_sn
        });

      });
      for (let i = 0; i < datas.list.length; i++) {
        if (!datas.list[i].num) {
          this.$alert("问题产品数未填写", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (!datas.list[i].type) {
          this.$alert("问题类别未选项", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
      }
      this.$api.inSaleApi.inSaleStore(datas).then((res) => {
        if (res.data.orderPurchaseIds != undefined) {
          res.msg = res.msg.replaceAll('\n', '<br/>',)
          this.$alert(res.msg, '提示', {
            dangerouslyUseHTMLString: true, center: true
          });
          return false
        }
        this.$message.success(res.msg);
        this.dialogVisible = false
        this.$parent.problemStoreSuccess();
      });
    },

    //查看二维码
    handlePictureCardPreview(url, indexs, code) {
      this.indexs = {
        items_i: indexs,
        code,
      };
      this.$api.base64({}, url).then(res => {
        this.dialogImageUrl = res;
        this.imgDialogVisible = true;
      })
    },
    //手机上传查询上传的图片地址
    getMobileUploadImage() {
      let datas = {
        code: this.indexs.code
      }
      let image = this.problemList[this.indexs.items_i].image
      this.$api.problemApi.getMobileUploadImage(datas).then(res => {
        res.data.forEach((item, index) => {
          image[index].image = item.image
          image[index].checked = true
        })
        this.$forceUpdate()
      })
    },
    //问题类别全选
    allType(e, data) {
      if (data.checked) {
        this.problemList.forEach((item) => {
          if (item.checked) {
            item.type = e
          }
        });
      }
    },
    //批量填充
    bulkFilling(i) {
      this.problemList[i].list.forEach(item => {
        item.num = item.possible_num
      })
    },
  },
};
</script>

<style lang='scss' scoped>
.table {
  padding: 24px;
  background-color: #f8f8f8;

  ol {
    display: flex;
    font-size: 14px;
    height: 40px;
    background: #edeff4;
    border-radius: 0px 4px 0px 0px;
    color: #909399;
    font-weight: 600;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 15x 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;

      .template {
        text-align: left;
        width: 100%;

        p {
          line-height: 20px;
        }
      }

      .scope {

        p {
          line-height: 22px;
        }
      }

      .images {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .imgList {
          display: flex;
          flex-wrap: wrap;
          width: 120px;

          .imgs {
            margin: 0 10px 10px 0;
            width: 55px;

            &:nth-child(even) {
              margin-right: 0;
            }

            &:nth-child(n + 2) {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .img {
      img {
        width: 55px;
        height: 55px;
      }
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;

    .label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.3;
    overflow: hidden;
  }

  .flex2 {
    flex: 1.8;
  }

  .inSaleDetail {
    .head {
      height: 50px;
      display: flex;
      background: #545467;
      font-size: 14px;
      line-height: 50px;
      padding: 0 20px;
      color: #fff;
      position: relative;

      a {
        color: #fff;

        &:hover {
          text-decoration: underline;
        }
      }

      .btn {
        position: absolute;
        left: 69%;
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

/deep/.el-textarea__inner {
  height: 80px;
  padding: 3px;
}

.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;

}

/deep/.el-upload,
.el-upload__input {
  width: 55px;
  height: 55px;
  margin-bottom: 5px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/.el-upload-dragger {
  width: 55px;
  height: 55px;
}

.avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 55px;
  height: 55px;
  display: block;
  border-radius: 3px;

}

.important {
  background-color: #fee0c3 !important;
  color: #333;
}

.qrCodeUpload {
  width: 80px !important;
  padding: 5px 0;
  text-align: center !important
}

/deep/.dialog-footer {
  display: flex;
  justify-content: space-between;
  margin: 0 30px;
}
</style>